var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', [_c('texting-form', _vm._b({
    attrs: {
      "applications": [_vm.value],
      "readonlyAddressees": ""
    },
    on: {
      "posted": _vm.updateItem
    }
  }, 'texting-form', {
    recruitment: _vm.recruitment,
    initialForm: _vm.initialForm
  }, false)), _c('texting-list', _vm._b({
    staticClass: "mt-20 mt-lg-40"
  }, 'texting-list', {
    textings: _vm.textings
  }, false)), _c('v-pagination', {
    staticClass: "my-16",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }